export default "__VITE_PUBLIC_ASSET__bececdae__"